export default "__VITE_ASSET__ByCQbCYD__"